import React from "react";
import { Dropdown, Menu } from "antd";
import "./EllipsisMenu.scss";
import ellipsis from "../../assets/Images/ellipsis.svg";

const EllipsisMenu = ({ options = [] }) => {
  const menu = (
    <Menu className="actionMenuWrapper">
      {options.map((option, idx) => (
        <Menu.Item
          key={idx}
          onClick={option.onClick}
          className={option.highlight ? "active" : ""}
        >
          <span className="menu-item-content">
            {option.icon && <span className="menu-icon">{option.icon}</span>}
            <span className="ellipsis-options">{option.label}</span>
          </span>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
      <img
        src={ellipsis}
        alt="menu"
        className="ellipsis-icon"
        onClick={(e) => e.stopPropagation()}
      />
    </Dropdown>
  );
};

export default EllipsisMenu;
